import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

export default function HomeButton() {
  return (
    <HomeButtonStyle className="button is-link" to="/mobile">
      <span>Draft Home</span>
    </HomeButtonStyle>
  )
}

const HomeButtonStyle = styled(Link)`

`



// WEBPACK FOOTER //
// ./src/components/templates/mobileHome/HomeButton.js